module.exports = __webpack_public_path__ + "img/product-placeholder-23.d858681.png";